import React from 'react';

const UploadLogoContext = React.createContext();

export { UploadLogoContext };
